import { SidebarItem } from '@backstage/core-components';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { useCertInventoryVisible } from '../useCertInventoryVisible';

/**
 * Sidebar entry for the Certificate Inventory, rendered only for users allowed
 * to see it (see `certInventory.allowedGroups`).
 */
export const CertInventorySidebarItem = () => {
  const { visible } = useCertInventoryVisible();
  if (!visible) {
    return null;
  }
  return (
    <SidebarItem icon={VpnKeyIcon} to="cert-inventory" text="Cert Inventory" />
  );
};
